import Tennispointapp from './Tennispointapp'

export default Tennispointapp
